import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSPicService from '@/services/Operacoes/SLSPic.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function usePicList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSPicService = new SLSPicService();
  const refPicListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // {key: 'picid', label: 'Pic', sortable: false},
    { key: 'picdescricao', label: 'Descrição', sortable: true },
    { key: 'tipopicid', label: ' Pic', sortable: true },
    { key: 'picdata', label: 'Data Cadastro', sortable: true },
    { key: 'piciniciovalidade', label: 'Inicio Validade', sortable: true },
    { key: 'picterminovalidade', label: 'Termino Validade', sortable: true },
    { key: 'picdata', label: 'Data Cadastro', sortable: true },
    { key: 'picsituacao', label: 'Situação', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalPic = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('picid');
  const isSortDirDesc = ref(false);
  const statusFilter = ref(null);
  const overlay = ref(true);
  const isLoading = ref(false);

  const dataMeta = computed(() => {
    const localItemsCount = refPicListTable.value ? refPicListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPic.value,
    };
  });

  const refetchData = () => {
    refPicListTable.value.refresh();
  };

  // Comentado para evitar requisições desnecessárias
  // watch([currentPage, perPage, searchQuery, statusFilter], () => {
  //     refetchData()
  // })

  const fetchPic = (ctx, callback) => {
    isLoading.value = true;
    sLSPicService.findByUsuario({
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      const pics = data.filter((item) => item.picsituacao === 'Pendente');
      callback(pics);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalPic.value = total;
      isLoading.value = false;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    await sLSPicService.store(body);
    refetchData();
  };
  const Updated = async (body) => {
    await sLSPicService.update(body.picid, body);
    refetchData();
  };

  const removerData = async (id) => {
    await sLSPicService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem ';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchPic,
    tableColumns,
    perPage,
    currentPage,
    totalPic,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refPicListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
